import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/11_card_back_cat_glasses/11_card_back_cat_glasses"
 * Contains 1 texture(s)
 */
export class CardsBacks11CardBackCatGlassesAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/11_card_back_cat_glasses/11_card_back_cat_glasses';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '11_cat_glasses.png'
    ] as const;
}
